/**
 * Primary Navbar scroll chrome (mobile) — hide on scroll-down from the hero,
 * reappear on scroll-up; opaque cream bar after the hero swirl scene finishes.
 * Figma: Navigation Bar `1268:79308` (off-white).
 */

/** Mobile-only scroll hide/show + opaque scrolled bar (`lg` and up keep absolute hero overlay). */
export const NAVBAR_MOBILE_SCROLL_MEDIA_QUERY = '(width < 64rem)' as const;

/** Ignore sub-threshold scroll jitter when deciding direction (native scroll path). */
export const NAVBAR_SCROLL_DELTA_PX = 8;

/**
 * Near-top band: force the bar visible (and treat as not scrolled for hide).
 * Lets the first scroll-down in the hero hide immediately without fighting
 * rubber-band / sub-pixel jitter at `scrollY === 0`.
 */
export const NAVBAR_TOP_THRESHOLD_PX = 8;

/** Hero landmark — reduced-motion / no-GSAP fallback for opaque chrome. */
export const NAVBAR_HERO_SENTINEL_ID = 'hero' as const;

/** Opaque surface after swirl done (or past-hero fallback). */
export const NAVBAR_DATA_SCROLLED = 'data-scrolled' as const;

/** Scroll-down hide (transform). Cleared on scroll-up, near top, and while the menu is open. */
export const NAVBAR_DATA_HIDDEN = 'data-nav-hidden' as const;

/**
 * StickyNav `inset-block-start` while the fixed opaque navbar is visible.
 * Matches `--mobile-nav-height` in `Navbar.module.css` (5.5rem / 88px).
 */
export const SITE_MOBILE_NAVBAR_OFFSET_VAR = '--site-mobile-navbar-offset' as const;

export const SITE_MOBILE_NAVBAR_OFFSET_VALUE = '5.5rem' as const;
